// CartManager
class CartManager {
  constructor() {
    let self = undefined;

    const CART_REQUEST_TYPES = {
      ADD: 'add',
      UPDATE: 'update',
      CHANGE: 'change',
      REMOVE: 'remove',
      CLEAR: 'clear',
    };

    this.cart_request_type = CART_REQUEST_TYPES;
    
    this.itemRewardsToExclude = [];
  }

  async getCart() {
    var shopifyCart = await this.fetchCart();
    var cart = JSON.parse(JSON.stringify(shopifyCart));
    return cart;
  }

  async updateNote(note, options) {
    const formData = {
      note: note,
    };
    return this.postShopify(formData, this.cart_request_type.UPDATE, {
      onSuccess:
        options && typeof options.onSuccess === 'function'
          ? options.onSuccess
          : function () {},
      onFailure:
        options && typeof options.onFailure === 'function'
          ? options.onFailure
          : function () {},
      always:
        options && typeof options.always === 'function'
          ? options.always
          : function () {},
    });
  }

  async updateAttibute(attributes, options) {
    const formData = {
      attributes: attributes
    };
    return this.postShopify(formData, this.cart_request_type.UPDATE, {
      onSuccess:
        options && typeof options.onSuccess === 'function'
          ? options.onSuccess
          : function () {},
      onFailure:
        options && typeof options.onFailure === 'function'
          ? options.onFailure
          : function () {},
      always:
        options && typeof options.always === 'function'
          ? options.always
          : function () {},
    });
  }

  handleErrors(options) {
    const errorMessage =
      options.status + ' ' + options.message + ' ' + options.description;
    return errorMessage;
  }

  async addItem(variant_id, quantity, properties, options) {
    const formData = {
      items: [
        {
          id: variant_id,
          quantity: quantity,
          properties: properties,
        },
      ],
    };
    this.postShopify.bind(this)(formData, 'add', options);
  }

  async updateItems(requests, onAllExecuted) {
    if (!Array.isArray(requests)) requests = [requests];
    let shopifyRequestsList = [];
    // In update requests we can add many items, as a map of id/key:quantity
    let shopifyUpdateRequest = {
      updates: {},
    };
    // In add requests we can add many items, as an object
    let shopifyAddRequest = {
      items: [],
    };
    for (let request of requests) {
      let action = request.type;
      let items = request.items;
      if (action == this.cart_request_type.ADD) {
        for (let item of items) {
          if (!item.id || isNaN(item.quantity)) {
            console.error(
              'To add a new item both properties: ID & QUANTITY are required',
              item,
            );
            continue;
          }

          let cartItem = {
            id: item.id,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          shopifyAddRequest.items.push(cartItem);
        }
      } else if (action == this.cart_request_type.UPDATE) {
        for (let item of items) {
          if (!item.key || isNaN(item.quantity)) {
            console.error(
              'To update an existing item, both properties: KEY & QUANTITY are required',
              item,
            );
            continue;
          }

          let cartItem = {
            id: item.key,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          // TODO: Test if a normal item can be converted to a subscription using the change request.

          if (cartItem.properties)
            shopifyRequestsList.push({
              type: this.cart_request_type.CHANGE,
              body: cartItem,
            });
          else shopifyUpdateRequest.updates[cartItem.id] = cartItem.quantity;
        }
      } else if (action == this.cart_request_type.REMOVE) {
        for (let item of items) {
          if (!item.key) {
            console.error('To remove an existing item KEY is required', item);
            continue;
          }

          shopifyUpdateRequest.updates[item.key] = 0;
        }
      }
    }
    if (Object.keys(shopifyUpdateRequest.updates).length)
      shopifyRequestsList.push({
        type: this.cart_request_type.UPDATE,
        body: shopifyUpdateRequest,
      });
    if (shopifyAddRequest.items.length)
      shopifyRequestsList.push({
        type: this.cart_request_type.ADD,
        body: shopifyAddRequest,
      });

    let requestsCount = Object.keys(shopifyRequestsList).length;
    let onFinishedContext = {requests_count: requestsCount};
    let onFinished = function () {
      --this.requests_count;
      if (!this.requests_count && typeof onAllExecuted === 'function')
        onAllExecuted();
    }.bind(onFinishedContext);

    for (let shopifyRequest of shopifyRequestsList) {
      await this.postShopify(shopifyRequest.body, shopifyRequest.type, onFinished);
    }

    return onAllExecuted();
  }

  clearCart() {
    const formData = {};
    this.postShopify.bind(this)(formData, 'clear');
  }

  postShopify(formData, action, options) {
    var self = this;
    var url = false;

    // Create a queue if it is not created yet.
    if (!Array.isArray(self.requestsQueue)) self.requestsQueue = [];

    // Add the new request at the beginning of queue.
    const newRequest = {
      formData,
      action,
      options,
    };
    self.requestsQueue.unshift(newRequest);

    // Replace the current request (queued at the end) with the next request in line.
    const currentRequest = self.requestsQueue.pop();
    formData = currentRequest.formData;
    action = currentRequest.action;
    options = currentRequest.options || {};

    if (!options.onSuccess || typeof options.onSuccess !== 'function')
      options.onSuccess = function () {};
    if (!options.onFailure || typeof options.onFailure !== 'function')
      options.onFailure = function () {};
    if (!options.always || typeof options.always !== 'function')
      options.always = function () {};

    if (action == this.cart_request_type.ADD) {
      url = window.routes.cartAddJS;
    } else if (action == this.cart_request_type.UPDATE) {
      url = window.routes.cartUpdateJS;
    } else if (action == this.cart_request_type.CHANGE) {
      url = window.routes.cartChangeJS;
    } else if (action == this.cart_request_type.CLEAR) {
      url = window.routes.cartClearJS;
    }
    // Ignore request as it doesn't match any of the available actions
    // If there are still requests in the queue, handle the next in line.
    else if (self.requestsQueue.length) {
      const nextRequest = self.requestsQueue.pop();
      return self.postShopify(
        nextRequest.formData,
        nextRequest.action,
        nextRequest.options,
      );
    }
    // Otherwise, end execution.
    else
      return console.error(
        `Can't post to Shopify. The action: ${action} is not valid`,
      );

    // Execute request
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      body: JSON.stringify(formData),
    })
      .then(function (response) {
        if (response.ok) return response.json();
        throw Error(response.statusText);
      })
      .then(function (cart) {
        try {
          options.onSuccess();
        } catch (e) {
          console.error(
            'Error executing onSuccess callback from postShopify',
            e,
          );
        }

        return {cart};
      })
      .catch(function (error) {
        self.handleErrors(error);

        try {
          options.onFailure();
        } catch (e) {
          console.error(
            'Error executing onFailure callback from postShopify',
            e,
          );
        }

        return {err: error};
      })
      .finally(function () {
        try {
          options.always();
        } catch (e) {
          console.error('Error executing always callback from postShopify', e);
        }

        // Handle next request if there are any in the queue.
        if (self.requestsQueue.length) {
          const nextRequest = self.requestsQueue.pop();
          return self.postShopify(nextRequest.formData, nextRequest.action);
        }
      });
  }

  async fetchCart(async) {
    var req = fetch(window.routes.cartJSON);

    if (async) {
      return req.then((response) => response.json());
    } else {
      var res = await req;
      return await res.json();
    }
  }
}

window.cartManager = new CartManager();